import {
  type GradeElementaryMiddle,
  type GradeHigh,
  type Revision,
  REVISION_KO,
  SCHOOL_TYPE_KO_ABBR,
  type SchoolType,
  type Semester,
  SUBJECT_HIGH_SHORT,
} from '~/@entities/SchoolSystem'

import { SUBJECT_HIGH_KO_BY_TRIE_KEY } from './constants'
import type { CurriculumCoreItem, TrieKey } from './schemas'

type CurriculumCoreLabels = Pick<
  CurriculumCoreItem,
  'label' | 'labelShort' | 'labelWithoutSchoolType' | 'labelWithSpace'
>

/** 학년·학기·과목의 표기 넷. 15개정은 개정 표기를 붙이지 않는다 */
export const formatCurriculumCoreLabels = (item: {
  trieKey: TrieKey
  revision: Revision
  schoolType: SchoolType
  gradeSubject: GradeElementaryMiddle | GradeHigh
  semester: Semester
}): CurriculumCoreLabels => {
  const revision = item.revision !== 'CURRICULUM_15' ? `(${REVISION_KO[item.revision]})` : ''

  if (item.schoolType === 'HIGH') {
    const label = `${item.gradeSubject}${revision}`
    const subject =
      (SUBJECT_HIGH_KO_BY_TRIE_KEY as Partial<Record<TrieKey, GradeHigh>>)[item.trieKey] ??
      (item.gradeSubject as GradeHigh)
    const labelShort = `${SUBJECT_HIGH_SHORT[subject]}${revision}`
    return { label, labelShort, labelWithoutSchoolType: labelShort, labelWithSpace: label }
  }

  const school = SCHOOL_TYPE_KO_ABBR[item.schoolType]
  const label = `${school}${item.gradeSubject}${item.semester ? `-${item.semester}` : ''}${revision}`
  const labelWithoutSchoolType = `${item.gradeSubject}${item.semester ? ` - ${item.semester}` : ''}${revision}`
  return {
    label,
    labelShort: label,
    labelWithoutSchoolType,
    labelWithSpace: `${school} ${labelWithoutSchoolType}`,
  }
}

/** 표기에서 개정 꼬리표('(22개정)' 등)를 뗀다 */
export const removeRevisionKoFromLabel = (label: string) => label.replace(/\(.*?개정\)/g, '')
